import { useCallback } from "react";
import { useAPIAction, UserAccountApi } from "melco-shared-logic";
import { useParams } from "react-router-dom";

export const useUserProductStartTrial = () => {


  const { userId } = useParams<{
    userId: string;
  }>();

  const [startTrialProducts] = useAPIAction(UserAccountApi,
    async (api, productCode: string, productVersion: string) => {




      const data = await api.subscriptionStartTrial({
        productCode,
        versionNumber: productVersion
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: userId },
      translationPrefix: "users.products.actions.start_trial",
    }
  );

  return useCallback(
    async (productCode: string, productVersion: string) => {
      const successfullystartTrialed: string[] = [];
      try {
        await startTrialProducts(productCode, productVersion);
        successfullystartTrialed.push(productCode);
      }
      catch (e) {
        // exception already handled in useAPIAction
      }
      return successfullystartTrialed;
    },
    [startTrialProducts]
  );


}